<template>
    <div>
        <v-btn v-if="this.isStudent && this.periodComplete"  :loading="loading4" :disabled="loading4" @click="loader = 'loading4'; downloadStudentGrades()">Download Grades</v-btn>
        <v-btn v-if="this.isTeacher" :loading="loading4" :disabled="loading4" @click="loader = 'loading4'; loadDialog()">Download Grades</v-btn>
        <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            Select your download
          </v-card-title>
          <v-card-text>
            <v-select
              :items="select"
              item-value="value"
              v-model="selected"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="unloadDialog()">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.stop="downloadTeacherGrades()" v-bind:disabled="disableAccept" >Accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    
</template>

<script>

import { globalStore } from '../main.js'
import { createFileWithStudentEfforts } from '../utils/effort-tracking-api.js'
import { getCsvFile, downloadFile, createFileWithTeacherEfforts} from '../utils/effort-tracking-api.js'


export default {
    name: 'grades-downloader',
    props: ['classId', 'isStudent', 'isTeacher' ],
    data () {
        return {
            loader: null,
            loading4: false,
            dialog: false,
            select: [ { text: 'Download all grades', value: "0"}, { text: 'Download grades for selected class', value:"1"} ],
            selected: 0,
            disableAccept: true,
            periodComplete: false
        }
    },
    watch: {
      selected () {
          if(this.selected == 0){
              this.disableAccept = false;
          } else {
              this.disableAccept = (this.classId != 0 ? false : true);
          }
      }
    },
    methods: {
        unloadDialog(){
            this.dialog = false;
            this.selected = null;
            this.disableAccept = true;
        },
        loadDialog() {
            this.disableAccept = true;
            this.dialog = true;
        },
        downloadStudentGrades() {
            this.dialog = false;
            this.disableAccept = true;
            const l = this.loader
            this[l] = !this[l]
            var periodId = localStorage.getItem('period-selected');

            var studentId = this.$route.params.studentId;
            createFileWithStudentEfforts(studentId, periodId).then(fileName => { 
                console.log(fileName);
                var fileUrl = getCsvFile(fileName);
                downloadFile(fileUrl, fileName);
                this[l] = false;
                this.loader = null;
            })
            .catch(ex => console.log(ex));
        },

        downloadTeacherGrades() {
            this.dialog = false;
            
            const l = this.loader
            this[l] = !this[l]
            var teacherId = this.$route.params.teacherId;
            var periodId = localStorage.getItem('period-selected');
            var _classId = 0;

            if(this.selected == 1){
                _classId = this.classId;
            }

            createFileWithTeacherEfforts(teacherId, _classId, periodId).then(fileName => {
                console.log(fileName);
                var fileUrl = getCsvFile(fileName);
                downloadFile(fileUrl, fileName);
                this[l] = false;
                this.loader = null;
                this.selected = null;
            })
            .catch(ex => console.log(ex));
        }
    },
    mounted() {
        var periods = this.$store.state.periods;
        var periodId = localStorage.getItem('period-selected');
        var period = periods.filter(pp => pp.id == periodId);
        this.periodComplete = period.length > 0 ? period[0].complete : false;
        this.selected = 0;
    }
}
</script>


// WEBPACK FOOTER //
// src/components/GradesDownloader.vue